

<div>
  <span [class.avatar]="rounded"
    [style.min-width.px]="size"
    [style.min-height.px]="size"
    [style.max-width.px]="size"
    [style.max-height.px]="size">
    <a (click)="fileInput.click()" [class.avatar]="!!rounded">
      @if (localImageUrl) {
        <img class="media-object" [class.rounded-circle]="!!rounded" [src]="localImageUrl | safe:'url'" alt=""
          [style.min-width.px]="size"
          [style.min-height.px]="size"
          [style.max-width.px]="size"
          [style.max-height.px]="size">
      }
      @if (!localImageUrl && imageUrl && type) {
        <img class="media-object" [class.rounded-circle]="!!rounded" [src]="imageUrl | imageUrl:type | safe:'url'" alt=""
          [style.min-width.px]="size"
          [style.min-height.px]="size"
          [style.max-width.px]="size"
          [style.max-height.px]="size">
      }
    </a>
  </span>
  <input type="file" #fileInput (change)="fileChanged($event)" accept="image/*">
</div>
